<template>
  <pages-home-block
    :block="block"
  />
</template>

<script>
// Modules
import PagesHomeBlock from 'pages/home/Block';

// Images
const images = {
  ourMission: require(`images/home/our-mission.svg`),
  tick: require(`images/icons/tick.svg`),
};

export default {
  name: `ui-our-mission`,

  // Compononts
  components: {
    PagesHomeBlock,
  },

  // Data
  data () {
    return {
      block: {
        slug: `why`,
        block: `lightest`,
        image: {
          image: images.ourMission,
          alt: `Our Mission`,
        },
        content: {
          heading: `Building trust through transparency.`,
          copy: [
            `VeriTooth was created to help dentists and patients verify the quality of the work \
            that patients receive. We strive to provide tools for you to demonstrate quality to \
            your patients. It's completely secure, unbiased, and impartial.`,
          ],
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// OurMission.vue?217cda12